import icon from 'vue-svgicon';

icon.register({
    'regular/alert-diamond': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M12 16.5a.375.375 0 1 0 .375.375A.375.375 0 0 0 12 16.5h0" stroke-linejoin="round" _fill="none" _stroke="#000" stroke-linecap="round" stroke-width="1.5"/><path pid="1" stroke-miterlimit="10" _fill="none" _stroke="#000" stroke-linecap="round" stroke-width="1.5" d="M12 13.5V6"/><path pid="2" d="M1.28 13.281a1.812 1.812 0 0 1 0-2.561l9.44-9.439a1.808 1.808 0 0 1 2.56 0l9.44 9.439a1.812 1.812 0 0 1 0 2.561l-9.44 9.439a1.811 1.811 0 0 1-2.56 0z" stroke-linejoin="round" _fill="none" _stroke="#000" stroke-linecap="round" stroke-width="1.5"/>`,
    },
});
